<div
  class="block w-full relative bg-gray-100"
  [ngStyle]="{ padding: linePadding }"
>
<div class="max-w-6xl mx-auto">
<div>
  <vsf-title-box
      [titleInfo]="titleInfo"
      [forComponent]="true">
  </vsf-title-box>
</div>
<div class="relative w-full overflow-hidden px-4 py-5">
  <div #collectionCarouselContainer
       class="flex justify-center gap-[var(--items-margin)] scroll-smooth snap-x snap-mandatory">
    <div *ngFor="let collection of displayedCollections; trackBy: trackByCollectionId"
         class="transition-shadow duration-300 hover:shadow-xl snap-center"
         [style.width]="'calc(90% / ' + itemsPerPage + ')'"
         [style.flex]="'0 0 auto'">
      <vsf-collection-card
        [collection]="collection"
        [colorConfig]="colorConfig">
      </vsf-collection-card>
    </div>
  </div>
  <button class="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white/80 p-2"
          (click)="showPreviousItems()"
          *ngIf="startIndex > 0">
    <fa-icon icon="chevron-left"></fa-icon>
  </button>
  <button class="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white/80 p-2"
          (click)="showNextItems()"
          *ngIf="startIndex + itemsPerPage < collectionLength">
    <fa-icon icon="chevron-right"></fa-icon>
  </button>
</div>
</div>
</div>
